export default __webpack_public_path__ + "static/media/illustrate-document-xlsx.24cafc85.svg";